<template>
  <span aria-hidden="true" class="hidden" />
</template>

<script setup lang="ts">
import { onUnmounted } from "vue"
import { registerSW } from "virtual:pwa-register"
import {
  handlePwaUpdateAvailable,
  initializePwaUpdateRegistration,
  teardownPwaUpdateService
} from "@/services/pwa-update-service"

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    void handlePwaUpdateAvailable()
  },
  onOfflineReady() {
    console.log("Content has been cached for offline use.")
  },
  onRegisteredSW(_swScriptUrl: string, registeredServiceWorker) {
    if (!registeredServiceWorker) return

    initializePwaUpdateRegistration(registeredServiceWorker, updateSW)
  },
  onRegisterError(error: unknown) {
    console.error("Error during service worker registration:", error)
  }
})

onUnmounted(() => {
  teardownPwaUpdateService()
})
</script>
